import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {apiInstance} from '../../api/api';

export default function PlanningReminders() {
    const [plans,setPlans] = useState([]), [error,setError] = useState(false);
    useEffect(()=>{
        let active=true;
        const load=async()=>{
            try {
                const response=await apiInstance.get('/replenishment-plans/',{params:{reminders:1}});
                if(active){setPlans(response.data);setError(false);}
            } catch(e) {
                if(active){setPlans([]);setError(e.response?.status!==403);}
            }
        };
        load();
        const timer=setInterval(()=>{if(document.visibilityState==='visible')load();},60000);
        return ()=>{active=false;clearInterval(timer);};
    },[]);
    if(error) return <p className="dash-error">Could not load today’s confirmed plan reminders.</p>;
    if(!plans.length) return null;
    return <div className="mt-3"><h6>Confirmed plans due today · {plans.length}</h6><ul className="dash-list">{plans.map(plan=><li key={plan.id}>
        <Link to="/inventory/replenishment-plans"><strong>{plan.title} · #{plan.id}</strong></Link>
        <p>{plan.party} · {plan.status==='REQUESTED'?'Transfer request sent':'Supplier plan confirmed'} · {plan.planned_date}</p>
    </li>)}</ul></div>;
}
